import { OPENAI_ACTION_TYPE } from "./Type";

const DEFAULT_STATE = {
  generateTaxPlan: { message: "", status: "idle", data: {} },
  getTaxPlan: { message: "", status: "idle", data: {} },
  deleteSavedTaxPlan: { message: "", status: "idle", data: {} },
  getTaxPlanHtml: { message: "", status: "idle", data: null },
  getTaxPlanStrategies: { message: "", status: "idle", data: {} },
  getTaxPlanJson: { message: "", status: "idle", data: {} },
};

const INITIAL_STATE = {
  ...DEFAULT_STATE,
};

const openAI = (state = INITIAL_STATE, action) => {
  if (action.type === OPENAI_ACTION_TYPE.generateTaxPlan) {
    return {
      ...state,
      generateTaxPlan: action.payload,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.generateTaxPlanIdle) {
    return {
      ...state,
      generateTaxPlan: DEFAULT_STATE.generateTaxPlan,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.getTaxPlan) {
    return {
      ...state,
      getTaxPlan: action.payload,
    };
  }
    if (action.type === OPENAI_ACTION_TYPE.deleteSavedTaxPlan) {
    return {
      ...state,
      deleteSavedTaxPlan: action.payload,
    };
  }
    if (action.type === OPENAI_ACTION_TYPE.getTaxPlanHtmlIdle) {
    return {
      ...state,
      getTaxPlanHtml: DEFAULT_STATE.getTaxPlanHtml,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.getTaxPlanHtml) {
    return {
      ...state,
      getTaxPlanHtml: action.payload,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.getTaxPlanStrategies) {
    return {
      ...state,
      getTaxPlanStrategies: action.payload,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.getTaxPlanStrategiesIdle) {
    return {
      ...state,
      getTaxPlanStrategies: DEFAULT_STATE.getTaxPlanStrategies,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.getTaxPlanJson) {
    return {
      ...state,
      getTaxPlanJson: action.payload,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.getTaxPlanJsonIdle) {
    return {
      ...state,
      getTaxPlanJson: DEFAULT_STATE.getTaxPlanJson,
    };
  }
  if (action.type === OPENAI_ACTION_TYPE.resetTaxPlanGenerator) {
    return {
      ...INITIAL_STATE,
    };
  }
  return state;
};

export default openAI;